import React, { useState, Component } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    service: 'corporate-law'
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = `Contact Form: ${formData.service} Inquiry from ${formData.name}`;
    const body = `Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Company: ${formData.company}
Service: ${formData.service}
Message: ${formData.message}`;
    const mailtoLink = `mailto:niqqannoconsult21@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      message: '',
      service: 'corporate-law'
    });
  };
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-75">
          <h2 className="text-primary font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-76">
            Contact Us
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-8" data-id="element-77"></div>
          <p className="text-gray-700" data-id="element-78">
            Reach out to discuss how Niqqanno Consulting can help your business
            thrive through expert legal counsel and strategic business
            solutions.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-79">
          {/* Contact Information */}
          <div className="w-full lg:w-2/5 bg-primary-dark text-white p-8 md:p-12" data-id="element-80">
            <h3 className="font-serif text-2xl font-bold mb-8" data-id="element-81">Get in Touch</h3>
            <div className="space-y-6 mb-12" data-id="element-82">
              <div className="flex items-start" data-id="element-83">
                <MapPin className="text-gold mr-4 flex-shrink-0" data-id="element-84" />
                <div data-id="element-85">
                  <h4 className="font-bold mb-1" data-id="element-86">Visit Us</h4>
                  <p className="text-gray-300" data-id="element-87">
                    Suite 1-3 Kebbi House,
                    <br data-id="element-88" />
                    Plot 70, Mohammed Kur Way
                    <br data-id="element-89" />
                    CBD Abuja
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-90">
                <Mail className="text-gold mr-4 flex-shrink-0" data-id="element-91" />
                <div data-id="element-92">
                  <h4 className="font-bold mb-1" data-id="element-93">Email Us</h4>
                  <p className="text-gray-300" data-id="element-94">niqqannoconsult21@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-95">
                <Phone className="text-gold mr-4 flex-shrink-0" data-id="element-96" />
                <div data-id="element-97">
                  <h4 className="font-bold mb-1" data-id="element-98">Call Us</h4>
                  <p className="text-gray-300" data-id="element-99">08164144775</p>
                </div>
              </div>
            </div>
            <div data-id="element-100">
              <h4 className="font-bold mb-4" data-id="element-101">Business Hours</h4>
              <div className="space-y-2 text-gray-300" data-id="element-102">
                <p data-id="element-103">Monday - Friday: 9:00 AM - 6:00 PM</p>
                <p data-id="element-104">Saturday: By appointment only</p>
                <p data-id="element-105">Sunday: Closed</p>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="w-full lg:w-3/5 p-8 md:p-12" data-id="element-106">
            <h3 className="font-serif text-2xl text-primary font-bold mb-8" data-id="element-107">
              Send Us a Message
            </h3>
            <form onSubmit={handleSubmit} data-id="element-108">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-109">
                <div data-id="element-110">
                  <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-111">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-112" />
                </div>
                <div data-id="element-113">
                  <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-114">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-115" />
                </div>
                <div data-id="element-116">
                  <label htmlFor="phone" className="block text-gray-700 mb-2" data-id="element-117">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-118" />
                </div>
                <div data-id="element-119">
                  <label htmlFor="company" className="block text-gray-700 mb-2" data-id="element-120">
                    Company Name
                  </label>
                  <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-121" />
                </div>
              </div>
              <div className="mb-6" data-id="element-122">
                <label htmlFor="service" className="block text-gray-700 mb-2" data-id="element-123">
                  Service of Interest *
                </label>
                <select id="service" name="service" value={formData.service} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-124">
                  <option value="corporate-law" data-id="element-125">Corporate Law</option>
                  <option value="business-strategy" data-id="element-126">Business Strategy</option>
                  <option value="both" data-id="element-127">Both Services</option>
                </select>
              </div>
              <div className="mb-8" data-id="element-128">
                <label htmlFor="message" className="block text-gray-700 mb-2" data-id="element-129">
                  Your Message *
                </label>
                <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:outline-none rounded-md transition-colors duration-300" data-id="element-130"></textarea>
              </div>
              <button type="submit" className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-gold hover:text-primary-dark transition-colors duration-300" data-id="element-131">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};